import {getRechargeCustomers} from '@/services/global.service';
import {homePage} from '@/config';
import {triggerDownloadReward} from '@/pages/home/home.service';
import {progressiveToastFail} from '@fe-progressive/package-progressive/progressive-toast';
import {goTo} from '@/utils';
import type {MutableRefObject} from 'react';
import type {i18n as I18nApi} from 'i18next';
import type {RechargeAdapter} from '@fe-progressive/package-progressive/recharge';

function pickImCustomer(
  customers: {imUserId: string; imUserStatus?: string}[],
  status?: string,
): string {
  if (status) {
    const list = customers.filter(c => c.imUserStatus === status);
    return list.length
      ? list[Math.floor(Math.random() * list.length)].imUserId
      : pickImCustomer(customers);
  }
  return customers[Math.floor(Math.random() * customers.length)].imUserId;
}

export type RechargeProgressiveAdapterOptions = {
  i18n: I18nApi;
  setLoading: (v: boolean) => void;
  holdLoadingForRedirectRef: MutableRefObject<boolean>;
};

export function createRechargeProgressiveAdapter(
  opts: RechargeProgressiveAdapterOptions,
): RechargeAdapter {
  const {i18n, setLoading, holdLoadingForRedirectRef} = opts;

  return {
    onRewardTrigger: async () => {
      await triggerDownloadReward({trigger_type: 2});
    },
    onImRecharge: async ({amount}) => {
      holdLoadingForRedirectRef.current = true;
      try {
        const customers = await getRechargeCustomers();
        const rechargeCustomers = customers.filter(
          (c: {imCustomer?: string}) => c.imCustomer === '1',
        );
        if (rechargeCustomers.length <= 0) {
          holdLoadingForRedirectRef.current = false;
          setLoading(false);
          progressiveToastFail(
            i18n.t('recharge-page.tip.no-recharge-customer'),
          );
          return;
        }
        goTo(homePage, {
          screen: 'Chat',
          params: {
            amount,
            customerId: pickImCustomer(rechargeCustomers, '1'),
          },
        });
      } catch {
        holdLoadingForRedirectRef.current = false;
        setLoading(false);
      }
    },
  };
}
